module.exports = __webpack_public_path__ + "img/jinsuolu.6e521c9d.png";